<button
  class="btn btn-link"
  id="fullScreenToggleBtn"
  (click)="onFullScreenToggle()"
>
  <fa-icon icon="expand" aria-hidden="true"></fa-icon>
  <span class="sr-only">Full screen</span>
</button>
